export enum SORT_DIRECTION {
  ASC = "ASC",
  DESC = "DESC",
  ASCEND = "ASC",
  DESCEND = "DESC",
}

export interface DefaultQueryParam {
  pageLimit: number;
  keyword?: string;
  pageNum: number;
  sortType: string;
  sortDirection: SORT_DIRECTION;
  tags?: string | null;
  type?: string | null;
  status?: string | null;
  category?: string | null;
  r?: string;
}

export interface BasePagination extends DefaultQueryParam {
  total: number;
}
export interface PageTotalStatus {
  totalTitle: string;
  totalValue: number;
}

export enum HTTP_RESULT {
  OK = "OK",
  NOK = "NOK",
}

export enum SORT_TYPE {
  ASC = "ASC",
  DESC = "DESC",
}

export enum LEVEL_TYPE {
  DW = "DW",
  EU = "EU",
  SP = "SP",
  CP = "CP",
  INTL = "",
}
export interface GetListQuery {
  pageNum: number;
  pageLimit: number;
  keyword: string;
  sortType: string;
  sortDirection: SORT_TYPE;
  accountId: string;
}

export enum ALERT_DETECT_TIME {
  DAY = "DAY",
  HOUR = "HOUR",
  MIN = "MINUTE",
}

export enum REPORT_DETECT_TIME {
  WEEK = "WEEK",
  MONTH = "MONTH",
}

export interface Validate {
  [key: string]: boolean;
}
export interface ValidateMsg {
  [key: string]: string;
}

export interface CustomError extends Error {
  response?: {
    data: {
      error: number;
      errorString: string;
      result: any;
    };
    status: number;
    headers: string;
  };
}

export interface CommonResponse {
  error: number;
  errorString: string;
}

export interface CommonLocation {
  id: number;
  location: string;
  locationCity: string;
  locationState: string;
  state: string;
  country: string;
  latitude: number;
  longitude: number;
}

export interface CommonPageResponse {
  error: number;
  errorString: string;
  page: PageResponse;
}

export interface PageResponse {
  total: number;
  pageNum: number;
  pageLimit: number;
  keyword: string;
  sortType: string;
  sortDirection: SORT_DIRECTION;
}
